<template>
    <div class="incubator-detail">
        <v-form>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        參賽組別
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.team.type"
                        class="radio-group"
                        readonly
                    >
                        <v-radio
                            value="非正式立案組織（個人團隊）"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    非正式立案組織（個人團隊）
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="非營利組織"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    非營利組織
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="營利組織"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    營利組織
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        組織登記地區
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-select
                            v-model="form.team.country"
                            :items="countries"
                            outlined
                            label="國家"
                            class="form-inputform-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                        <v-text-field
                            v-if="form.team.country !== '臺灣'"
                            v-model="form.team.city"
                            outlined
                            :label="`國家`"
                            placeholder=""
                            persistent-hint
                            class="form-inputform-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                        <v-select
                            v-else
                            v-model="form.team.city"
                            :items="cities"
                            outlined
                            label="城市"
                            class="form-inputform-input"
                            readonly
                            background-color="#F2F2F2"
                            style="margin-left: 20px"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        團隊資料
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-text-field
                            v-model="form.team.name"
                            outlined
                            label="團隊名稱"
                            placeholder=""
                            hint="必填"
                            persistent-hint
                            class="form-inputform-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        提案資料
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-text-field
                            v-model="form.proposal.name"
                            outlined
                            label="計畫名稱"
                            placeholder=""
                            hint="必填"
                            persistent-hint
                            class="form-inputform-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        團隊屬性
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.property"
                        class="radio-group"
                        readonly
                    >
                        <v-radio
                            value="臺灣團隊-孵化組"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    臺灣團隊-孵化組
                                </div>
                            </template>
                        </v-radio>
                        <div class="radio-content">
                            <p>
                                適合已形成初步公益行動構想或服務方案，目前正處於需求驗證、方案測試及營運基礎建立階段之團隊。<br>
                                符合下列情況者，原則上適合申請孵化組：
                            </p>
                            <ol>
                                <li>
                                    已提出初步服務、產品或行動方案，但尚未正式執行，或僅完成初步試辦。
                                </li>
                                <li>服務對象需求、解決方案或執行方式仍待進一步驗證與調整。</li>
                                <li>
                                    團隊分工、執行流程、資源取得方式或成果衡量方式仍在建立階段。
                                </li>
                                <li>
                                    未來一年主要發展目標為驗證需求、優化方案、建立穩定團隊及形成永續運作的服務或營運模式。
                                </li>
                            </ol>
                        </div>
                        <v-radio
                            value="臺灣團隊-加速組"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    臺灣團隊-加速組
                                </div>
                            </template>
                        </v-radio>
                        <div class="radio-content">
                            <p>
                                適合已實際執行計畫／專案，具備初步服務成果、穩定團隊及營運基礎，並準備進一步擴大或深化影響力之團隊。<br>
                                符合下列情況者，原則上適合申請加速組：
                            </p>
                            <ol>
                                <li>
                                    服務、產品或行動方案已實際執行，並已取得服務對象、使用者或合作夥伴的回饋。
                                </li>
                                <li>已具備穩定核心團隊、相對明確的角色分工及持續執行經驗。</li>
                                <li>
                                    服務模式、執行流程或營運模式已獲得初步驗證，並具備持續推動及進一步優化的基礎。
                                </li>
                                <li>
                                    <!-- eslint-disable-next-line max-len -->
                                    未來一年已有明確的成長或深化目標，例如擴大服務規模、拓展市場或合作夥伴、增加營收或募款來源、跨區執行、複製既有模式，或提升服務成效與影響力。
                                </li>
                            </ol>
                        </div>
                        <!-- 本屆無亞太地區團隊，暫時隱藏；恢復時將 showAsiaPacific 改回 true -->
                        <template v-if="showAsiaPacific">
                            <v-radio
                                value="亞太地區團隊"
                                color="#898989"
                            >
                                <template v-slot:label>
                                    <div class="radio-label">
                                        亞太地區團隊
                                    </div>
                                </template>
                            </v-radio>
                            <div class="radio-content">
                                <ol>
                                    <li>
                                        團隊所有成員皆須為40歲（含）以下青年，申請人必須符合本計畫之地區國籍。
                                    </li>
                                    <li>
                                        投件計畫/專案之團隊隊長與1位成員於孵化期間依計畫於臺灣進行實體培力課程、總導師與業師會議。
                                    </li>
                                    <li>計畫/專案已有明確回饋社會公益之方向及目標。</li>
                                    <li>計畫/專案期待在未來一年內調整與優化營運模式。</li>
                                </ol>
                            </div>
                        </template>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        提案內容
                    </div>
                </div>
                <div class="form-content">
                    <v-textarea
                        v-model="form.proposal.abstract"
                        rows="10"
                        counter="500"
                        label="提案內容"
                        no-resize
                        outlined
                        placeholder=""
                        hint="必填，500字以內"
                        persistent-hint
                        readonly
                        background-color="#F2F2F2"
                    />
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        議題
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.issue"
                        class="radio-group"
                        readonly
                    >
                        <v-radio
                            value="慈善共好"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    慈善共好
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="健康福祉"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    健康福祉
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="教育創新"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    教育創新
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="韌性城鄉"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    韌性城鄉
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="循環經濟"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    循環經濟
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="apply-form-block">
                    <div class="left-block">
                        <div class="block-title">
                            計畫書
                        </div>
                    </div>
                    <div class="form-content">
                        <div class="pdf-file">
                            <iframe
                                :src="getPDF($static(form.proposal.pdfFile))"
                                width="100%"
                                height="800"
                                frameborder="0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </v-form>
        <PointsForm
            :id="$route.params.id"
            :type="'incubator'"
            @setTotal="setTotal"
            @setDetailPoints="setDetailPoints"
            @setComments="setComments"
            @openDialog="openDialog"
        />
        <PointsDialog
            :id="$route.params.id"
            :type="'incubator'"
            :total="total"
            :is-open="isOpen"
            @closeDialog="closeDialog"
            @toApply="toApply"
        />
    </div>
</template>

<script>
import API from '@/api';
import _ from 'lodash';
import { mapMutations } from 'vuex';
import PointsForm from '@/components/PointsForm.vue';
import PointsDialog from '@/components/Dialog/PointsDialog.vue';

export default {
    components: { PointsForm, PointsDialog },
    data() {
        return {
            // 本屆無亞太地區團隊，評審評分頁暫時隱藏；恢復時改為 true
            showAsiaPacific: false,
            refersTeamName: '',
            refersRecommendName: '',
            refersPlatformName: '',
            refersOther: '',
            form: {
                team: {
                    organizeName: '', // 組織名稱
                    type: '', // 參賽組別
                    country: '', // 組織登記地區-國家
                    city: '', // 組織登記地區-城市
                    taxId: '', // 統一編號
                    name: '', // 團隊資料
                    members: [
                        {
                            name: '', // 團隊成員-姓名
                            phone: '', // 團隊成員-電話
                            email: '', // 團隊成員-email
                            department: '', // 團隊成員-單位職稱/學校系級
                            birthday: '', // 團隊成員-生日
                        },
                    ],
                },
                proposal: {
                    name: '', // 計畫名稱
                    property: '', // 團隊屬性
                    abstract: '', // 提案內容
                    issue: '', // 議題
                    pdfFile: '', // 計畫書
                    img: '', // 團隊照片
                },
                final: {
                    pdfFile: '', // 決審簡報
                },
            },
            status: '',
            countries: ['臺灣', '其他'],
            cities: [
                '臺北市',
                '新北市',
                '基隆市',
                '桃園市',
                '新竹市',
                '新竹縣',
                '苗栗縣',
                '臺中市',
                '彰化縣',
                '南投縣',
                '雲林縣',
                '嘉義市',
                '嘉義縣',
                '臺南市',
                '高雄市',
                '屏東縣',
                '宜蘭縣',
                '花蓮縣',
                '臺東縣',
                '澎湖縣',
                '金門縣',
                '連江縣',
            ],
            isOpen: false,
            total: 0,
            points: {
                impact: 0,
                innovation: 0,
                feasibility: 0,
                execution: 0,
            },
            comments: '',
        };
    },
    computed: {},
    created() {
        this.getData();
    },
    mounted() {},
    methods: {
        ...mapMutations('mNotification', ['handleError']),
        ...mapMutations('mLoading', ['setLoading']),
        async getData() {
            const { id } = this.$route.params;
            try {
                this.setLoading(true);
                const res = await API.IncubatorApply.PrivateFetchResource(id);
                this.form = res.data;
                this.setLoading(false);
            } catch (e) {
                console.log('error', e);
                this.setLoading(false);
                this.handleError({
                    message: e || '連線異常',
                    color: 'error',
                });
            }
        },
        getPDF(url) {
            return `https://docs.google.com/viewer?url=${url}&embedded=true`;
        },
        memberNameLabel(index) {
            if (index === 0) {
                return '隊長';
            }
            return `隊員${index}`;
        },
        setTotal(value) {
            this.total = value;
        },
        setDetailPoints(array) {
            _.assign(this.points, array);
        },
        setComments(value) {
            this.comments = value;
        },
        openDialog() {
            this.isOpen = true;
        },
        closeDialog() {
            this.isOpen = false;
        },
        toApply() {
            this.$router.push({ name: 'SubmittedRatingIncubatorApply' });
        },
    },
};
</script>

<style lang="scss">
@import "@/scss/apply.scss";

.incubator-detail {
    padding: 50px 40px;
    .member-file {
        flex: 1;
        display: flex;
        align-items: center;
        margin-top: -50px;
    }

    .team-image-block {
        .preview-card {
            width: 300px;
            height: 300px;
        }
    }

    .pdf-file {
        a {
            color: $color-orange;
            font-weight: 700;
            letter-spacing: 0.1em;
            margin-left: 5px;
        }
    }

    .actions {
        justify-content: center;

        .btn:first-child {
            margin-right: 30px;
        }
    }

    .radio-content {
        padding-left: 34px;
        margin-bottom: 10px;
    }
}
.checkbox-input {
    padding-top: 0 !important;
    margin-top: 0 !important;
    width: 100%;
    flex: unset;
}
.checkbox-input input {
    padding-left: 10px;
}
@media (min-width: 768px) {
    .checkbox-input {
        max-width: 185px !important;
    }
}
</style>
